export default __webpack_public_path__ + "static/media/ss-logo.302d671b.png";